import React from 'react';
import ListOrderDetail from './ListOrderDetail';
import type { RevenueData } from 'types/Revenue';

interface IProps {
  id: number;
  onData: RevenueData;
  isClosePanelRight(status: boolean): void;
}

const ListOrderTable = ({ onData, id, isClosePanelRight }: IProps) => {
  const currentList = onData.orders.find(
    (list) => Number(list.orderNumber) === id
  );

  return currentList ? (
    <ListOrderDetail
      isClosePanelRight={isClosePanelRight}
      orderNumber={currentList.orderNumber}
      dateAndTime={currentList.dateAndTime}
      name={currentList.name}
      subTotalPrice={currentList.subtotal}
      operationCosts={currentList.operationCost}
      refund={currentList.refund || null} // if data is 0, convert 0 to null so that same as other data
      refundCost={currentList.refundCost}
      taxRevenues={currentList.soldAt}
      netRevenues={currentList.netRevenue}
      deliveryFee={currentList.deliveryFee}
      itemsOriginal={currentList.itemsOriginal}
    />
  ) : null;
};

export default ListOrderTable;
